<template>
  <div>
    <InformationAlert />

    <!-- List Table -->
    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
      @click="pushDetail"
      detailUrl="/services/iam"
      :moduleName="`iam.plusCloudsIAM`"
    >
      <!-- :moduleCreateEvent="`subHeaderDetailOpen`"> -->

      <template v-slot:item.url="{ item }">
        {{ item.ldap_server_url + ':' + item.ldap_server_port }}
      </template>

      <template v-slot:item.is_connected="{ item }">
        <Label
          class="text-white"
          :class="item.is_connected ? `bg-success` : `bg-danger`"
          >{{
            $t(`global.${item.is_connected == 1 ? 'true' : 'false'}`)
          }}</Label
        >
      </template>

      <template v-slot:item.is_connection_secure="{ item }">
        <Label
          class="text-white"
          :class="item.is_connection_secure ? `bg-success` : `bg-danger`"
          >{{
            $t(`global.${item.is_connection_secure == 1 ? 'true' : 'false'}`)
          }}</Label
        >
      </template>

      <template v-slot:item.is_usable="{ item }">
        <Label
          class="text-white"
          :class="item.is_usable ? `bg-success` : `bg-danger`"
          >{{ $t(`global.${item.is_usable == 1 ? 'true' : 'false'}`) }}</Label
        >
      </template>

      <template v-slot:item.action="{ item }">
        <ActionButton
          icon="fas fa-pencil"
          :title="$t('global.update')"
          @click.native="openForUpdate(item)"
        ></ActionButton>
        <ActionButton
          icon="fas fa-eye"
          :title="$t('global.openDetail')"
          @click.native="pushDetail(item)"
        ></ActionButton>
        <!-- <DeleteButton icon="fad fa-trash"
                      :title="$t('global.delete')"
                      @click.native="openDeleteHandler(item)"></DeleteButton> -->
      </template>
    </List>
    <DeleteOperation :url="deleteOperationUrl" @updateList="getList" />

    <!-- Create Popup -->
    <DetailModal
      :title="
        $t(
          selectedItem == ''
            ? 'iam.createNewIAMService'
            : 'iam.updateIAMService'
        )
      "
      :show="showDetail"
      @closeDetail="closeDetail()"
      @confirm="confirmModal()"
      :resetForm="resetForm"
    >
      <ServiceForm
        :confirmModal="confirmCreate"
        @resetDetailForm="resetDetailForm"
        :selectedItem="selectedItem"
      />
    </DetailModal>
  </div>
</template>

<script>
// Utils
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import { SET_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'
import EventBus from '@/event-bus'

// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'IAMList',
  data() {
    return {
      showDetail: false,
      loading: false,
      confirmCreate: false,
      resetForm: false,
      header: [
        {
          text: 'global.name',
          value: 'name',
          clicked: true,
        },
        {
          text: 'global.type',
          value: 'type',
          clicked: true,
        },
        {
          text: 'global.url',
          value: 'url',
          copyField: true,
          size: '150px',
        },
        { text: 'gateways.is_connected', value: 'is_connected', size: '100px' },
        {
          text: 'gateways.is_connection_secure',
          value: 'is_connection_secure',
          size: '100px',
        },
        { text: 'gateways.is_usable', value: 'is_usable', size: '100px' },
        { text: 'global.actions', value: 'action', size: '120px' },
      ],
      data: [],
      pagination: {},
      meta: {},
      deleteOperationUrl: '',
      selectedItem: '',
      closeSecondModal: false,
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'iam.plusCloudsIAM',
        route: '/services/iam',
      },
    ])
    this.$store.dispatch(SET_CUSTOMHEADERPARAMS, {
      menuList: [
        {
          title: 'global.services',
        },
        {
          title: 'iam.plusCloudsIAM',
          route: '/services/iam',
        },
      ],
      showSearch: false,
      showDetailButton: false,
      // detailPlaceholder: 'iam.createNewIAMService',
    })

    EventBus.$on(`subHeaderDetailOpen`, this.listener)
  },
  beforeDestroy() {
    EventBus.$off(`subHeaderDetailOpen`, this.listener)
  },
  methods: {
    listener(payload) {
      this.selectedItem = ''
      this.showDetail = payload
    },
    getList() {
      this.loading = true

      const { current_page } = this.meta
      let $query = `iam?position=id|desc&page=${
        current_page ? current_page : 1
      }`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    openDeleteHandler(item) {
      this.deleteOperationUrl = `iam/${item.id}`
      this.$bvModal.show('modal-deleteOperation')
    },
    openForUpdate(item) {
      this.selectedItem = item
      this.showDetail = true
    },
    pushDetail(item) {
      this.$router.push(`/services/iam/${item.id}`)
    },
    confirmModal() {
      this.closeSecondModal = true
      setTimeout(() => {
        this.closeSecondModal = false
      }, 200)
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      this.closeSecondModal = true
      setTimeout(() => {
        this.closeSecondModal = false
      }, 200)
      if (closeDetail) {
        this.closeDetail()
        this.getList()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
    closeDetail() {
      this.showDetail = false
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
  components: {
    ServiceForm: () => import('@/components/forms/iam/ServiceForm'),
    InformationAlert: () => import('@/components/generic/InformationAlert'),
  },
}
</script>
